/**
 * Copyright © 2014 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 09.01.14, 13:52
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */
import { HTMLTextCustomVO } from "../../../../vos/HTMLTextCustomVO";
import { HTMLTextVO } from "../../../../vos/HTMLTextVO";

/**
 * @private
 */
export class HTMLTextComposer {
    public by(vo: HTMLTextVO): string {
        if (vo instanceof HTMLTextCustomVO) {
            return this.composeHTML(<HTMLTextCustomVO>vo);
        } else {
            return this.composeHTMLWithGGSLinks(vo);
        }
    }

    private composeHTMLWithGGSLinks(vo: HTMLTextVO): string {
        // Delete HTML nodes
        vo.htmlText.clearAllNodes();

        // Compose and add nodes to HTML
        for (let entryList of vo.localizedTextVOList) {
            let locaVO: any = entryList;

            vo.htmlText.appendChild(this.parseGGSLinksToFlashHTMLTextLinks(locaVO.compose()));
        }

        return vo.htmlText.toString();
    }

    private composeHTML(htmlTextVO: HTMLTextCustomVO): string {
        const html = (htmlTextVO.localizedTextVOList || [])
            .map(localizedTextVO => {
                return localizedTextVO.compose();
            })
            .join( htmlTextVO.appendTextGlue );

        return (htmlTextVO.htmlText = `<content>${html}</content>`);
    }

    private parseGGSLinksToFlashHTMLTextLinks(localizedTextWithGGSLinks: string): string {
        let textElements: any[] = localizedTextWithGGSLinks.split("<");
        let isLink: boolean = false;
        let htmlText: string = "<p>";

        for (let i: number = 0; i < textElements.length; i++) {
            if (isLink) {
                // add the link
                htmlText += this.createLinkElement(textElements[i]);
                isLink = false;
            } else {
                // add text to the spans
                htmlText += String(textElements[i]);
                isLink = true;
            }
        }
        htmlText += "</p>";

        const MATCH_EVERY_BREAK: RegExp = /\n/g;
        const BREAK: string = "<br>";

        return htmlText.replace(MATCH_EVERY_BREAK, BREAK);
    }

    private createLinkElement(text: string): string {
        let id: string = "";

        for (let i: number = 0; i < text.length; i++) {
            if (!isNaN(Number(text.substr(i, 1)))) {
                id += text.substr(i, 1);
            } else {
                break;
            }
        }

        let textString: string = text.substr(id.length);
        textString = '<a href="event:' + id + '">' + textString + "</a>";

        return textString;
    }
}
